module.exports = __webpack_public_path__ + "static/icon-thumb-fa0e8a5d9e2e0266275607f159865b18.svg";